import { supabase } from '@/lib/supabase';
import { toast } from 'sonner';

export const useLineItemImageSubmit = () => {
  // Handle image upload logic
  const uploadImages = async (imagePreviewUrls: string[]) => {
    if (imagePreviewUrls.length === 0) {
      console.log('No images to upload');
      return [];
    }

    const uploadedUrls: string[] = [];
    
    // Keep existing URLs that are not blob URLs (already stored in Supabase)
    const existingUrls = imagePreviewUrls.filter(url => 
      !url.startsWith('blob:')
    );
    
    uploadedUrls.push(...existingUrls);
    console.log('Keeping existing image URLs:', existingUrls);
    
    // Upload new files (blob URLs)
    const blobUrls = imagePreviewUrls.filter(url => url.startsWith('blob:'));
    console.log(`Processing ${blobUrls.length} new blob images`);
    
    for (const blobUrl of blobUrls) {
      try {
        // Fetch the blob data
        const response = await fetch(blobUrl);
        if (!response.ok) {
          console.error(`Failed to fetch blob: ${blobUrl}`);
          continue;
        }
        
        const blob = await response.blob();
        const fileName = `line-item-${Date.now()}-${Math.random().toString(36).substring(2, 15)}.${blob.type.split('/')[1] || 'png'}`;
        const filePath = `internal-line-items/${fileName}`;
        
        console.log(`Starting upload for ${fileName} to storage`);
        
        // Upload to Supabase Storage
        const { data, error } = await supabase.storage
          .from('line-item-images')
          .upload(filePath, blob);
          
        if (error) {
          console.error('Error uploading image:', error);
          toast.error(`Failed to upload image: ${error.message}`);
          continue;
        }
        
        // Get public URL
        const { data: publicUrlData } = supabase.storage
          .from('line-item-images')
          .getPublicUrl(filePath);
          
        if (publicUrlData && publicUrlData.publicUrl) {
          uploadedUrls.push(publicUrlData.publicUrl);
          console.log(`Uploaded image successfully. URL:`, publicUrlData.publicUrl);
        }
      } catch (error) {
        console.error('Error processing image:', error);
        toast.error('Failed to process image');
      }
    }
    
    console.log(`Image upload complete, got ${uploadedUrls.length} URLs:`, uploadedUrls);
    return uploadedUrls;
  };

  return { uploadImages };
};
